import { faCircleNotch, faEraser, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Fragment, useEffect, useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import store from '../../store';
import 'react-datepicker/dist/react-datepicker.min.css';
import './Filters.scss';
import { registerLocale } from  "react-datepicker";
import el from 'date-fns/locale/el';
import moment from 'moment/moment';
import { useSelector } from 'react-redux';
import searchSlice from './searchSlice';
registerLocale('el', el)

const Filters = (props) => {
  const filterValues = useSelector((state) => state.search.filters);

  const [dateFrom, setDateFrom] = useState(filterValues.dateFrom);
  const [dateTo, setDateTo] = useState(filterValues.dateTo);
  const [limit, setLimit] = useState(filterValues.limit);

  const searching = useSelector((state) => state.search.fetchingResults);

  const data = useSelector((state) => state.app.data);

  useEffect(() => {
    if (dateFrom) {
      if (dateTo === null) {
        setDateTo(moment(dateFrom).add(1, 'month').toDate());
      } else {
        if (moment(dateTo).isBefore(moment(dateFrom))) {
          setDateTo(moment(dateFrom).add(1, 'day').toDate());
        }
      }
    }
  }, [dateFrom]);

  useEffect(() => {
    if (dateTo) {
      if (dateFrom === null) {
        setDateFrom(moment().subtract(1, 'month').toDate());
      } else {
        if (moment(dateFrom).isAfter(moment(dateTo))) {
          setDateFrom(moment(dateTo).subtract(1, 'day').toDate());
        }
      }
    }
  }, [dateTo]);

  useEffect(() => {
    store.dispatch(searchSlice.actions.updateFilterValues({ dateFrom, dateTo, limit }));
  }, [dateFrom, dateTo, limit]);

  const onDateFromInputChange = (date) => {
    setDateFrom(date);
  };

  const onDateToInputChange = (date) => {
    setDateTo(date);
  };

  const onLimitInputChange = (e) => {
    let { value } = e.target;    
    setLimit(value);
  };
  
  const search = () => {
    // if (!searching && ((dateFrom !== null && dateTo !== null) || limit > 0)) {
    //   store.dispatch(searchSlice.actions.search({ dateFrom, dateTo, limit }));
    // }

    let results;
    if (dateFrom !== null && dateTo !== null) {
      results = data.filter((draw) => {
        return moment(draw.date).isAfter(moment(dateFrom)) &&
          moment(draw.date).isBefore(moment(dateTo));
      });
    } else {
      results = data.slice(0, limit);
    }
    store.dispatch(searchSlice.actions.updateResults(results));
  };
  
  const clearFilters = () => {
    setDateFrom(null);
    setDateTo(null);
    setLimit(10);
  };

  return (
    <div className="Filters">
      <div className="fields">
        <div className="date-from">
          <span>Ημ/νία Από</span>

          <ReactDatePicker
            locale="el"
            selected={dateFrom}
            onChange={onDateFromInputChange}
            enableTabLoop={false}
            dateFormat="dd/MM/yyyy"
            maxDate={new Date()}
            placeholderText="Π.χ. 01/01/2023"
          />
        </div>

        <div className="date-to">
          <span>Ημ/νία Έως</span>

          <ReactDatePicker
            locale="el"
            selected={dateTo}
            onChange={onDateToInputChange}
            enableTabLoop={false}
            dateFormat="dd/MM/yyyy"
            maxDate={new Date()}
            placeholderText="Π.χ. 01/02/2023"
          />
        </div>

        <div
          className="limit"
          style={{
            opacity: dateFrom !== null && dateTo !== null ? 0.5 : ''
          }}>
          <span>Όριο</span>

          <input
            type="number"
            value={limit}
            placeholder="Π.χ. 10"
            onChange={onLimitInputChange}
            disabled={dateFrom !== null && dateTo !== null}
          />
        </div>
      </div>

      <button
        className="btn-search"
        onClick={search}
        disabled={searching}
      >
        {
          searching
            ? <Fragment>
                <FontAwesomeIcon icon={faCircleNotch} spin size="lg" />
                <span>Παρακαλώ περιμένετε</span>
              </Fragment>
            : <Fragment>
                <FontAwesomeIcon icon={faSearch} size="lg" />
                <span>Εμφάνιση</span>
              </Fragment>
        }
      </button>

      <div className="search-info-text">
        {
          dateFrom === null || dateTo === null
            ? (limit > 0 ? limit + ' τελευταίες κληρώσεις' : '')
            : <Fragment>
                {
                  moment(dateFrom).format('D-M-YYYY') !== moment(dateTo).format('D-M-YYYY')
                    ? 'Κληρώσεις από ' + moment(dateFrom).format('D-M-YYYY') + ' έως ' + (moment().format('D-M-YYYY') === moment(dateTo).format('D-M-YYYY') ? ' σήμερα' : moment(dateTo).format('D-M-YYYY'))
                    : 'Κλήρωση ' + moment(dateFrom).format('D-M-YYYY')
                }
                &nbsp;
                <button onClick={clearFilters}>
                  <FontAwesomeIcon icon={faEraser} size="lg" />
                </button>
              </Fragment>
        }
      </div>
    </div>
  );
}

export default Filters;
